module.exports = __webpack_public_path__ + "static/PSM-cbf98361973f60c3e0efc67ae9c8bd20.png";